import { connect } from 'react-redux';
import { pauseTrackRoutine, replaceQueueRoutine } from 'redux-state/ducks/player';
import { addToFavoritesRoutine, removeFromFavoritesRoutine } from 'redux-state/ducks/favorites';
import ListResult from './list-result.component';

const mapStateToProps = ({ favorites, player }) => ({
  favorites: favorites.favorites,
  queue: player.queue,
  activeIndex: player.activeIndex,
  isPlaying: player.isPlaying,
  activePlaylistId: player.activePlaylistId,
});

const mapDispatchToProps = {
  pauseTrackAction: pauseTrackRoutine.request,
  replaceQueueAction: replaceQueueRoutine.request,
  addToFavoritesAction: addToFavoritesRoutine.request,
  removeFromFavoritesAction: removeFromFavoritesRoutine.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(ListResult);
